import { MessageStatus } from '@govbr-ds/react-components/dist/types/messages';
import { ETipoRelacionamentoVendaNacional } from '../../../../../../../../../../../../enums/ETipoRelacionamentoVendaNacional';
import { validarDocumento } from '../../../../../../../../../../../../utils/validarDocumento';

export const validarDadosPessoaRelacionada = (
  cnpjRelacionado: string,
  razaoSocialRelacionado: string,
  relacionamentoComPJ: ETipoRelacionamentoVendaNacional | undefined,
  mostrarNotificacao: (notificacao: { tipo: MessageStatus; conteudo: string }) => void
) => {
  if (!cnpjRelacionado || cnpjRelacionado.trim() === '') {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe o CNPJ da pessoa jurídica relacionada.',
    });
    return;
  }
  if (!razaoSocialRelacionado || razaoSocialRelacionado.trim() === '') {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe a Razão Social da pessoa jurídica relacionada.',
    });
    return;
  }
  if (!relacionamentoComPJ) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe o relacionamento com a pessoa jurídica.',
    });
    return false;
  }
  if (!validarDocumento(cnpjRelacionado)) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'CNPJ inválido.',
    });
    return false;
  }

  return true;
};
